import { Pipe, PipeTransform } from '@angular/core';
import { DateTimeService } from 'i2g-ng-utils';

@Pipe({
  name: 'momentDate',
})
export class MomentDatePipe implements PipeTransform {
  constructor(private _dateTimeService: DateTimeService) {}

  transform(date: string | Date, format: string): string {
    return this._dateTimeService.formatDate(date, format);
  }
}
